(() => {
  'use strict';

  const root = document.querySelector('[data-shem-brochure-root]');
  if (!root) return;

  const viewer = root.querySelector('[data-shem-brochure-viewer]');
  if (!viewer) return;

  const dialog = viewer.querySelector('[data-shem-brochure-dialog]');
  const frame = viewer.querySelector('[data-shem-brochure-frame]');
  const pageInput = viewer.querySelector('[data-shem-brochure-page]');
  const pageCurrent = viewer.querySelector('[data-shem-brochure-current]');
  const openers = root.querySelectorAll('[data-shem-brochure-open]');
  const closers = viewer.querySelectorAll('[data-shem-brochure-close]');
  const prev = viewer.querySelector('[data-shem-brochure-prev]');
  const next = viewer.querySelector('[data-shem-brochure-next]');
  const fullscreen = viewer.querySelector('[data-shem-brochure-fullscreen]');
  const pdfUrl = viewer.dataset.pdfUrl || '';
  const totalPages = Math.max(1, Number.parseInt(viewer.dataset.pages || '100', 10));

  if (!dialog || !frame || !pdfUrl) return;

  let page = 1;
  let lastFocus = null;
  let hasLoaded = false;

  const clampPage = (value) => Math.min(totalPages, Math.max(1, Number.parseInt(value, 10) || 1));

  const pageUrl = (targetPage) => {
    const base = pdfUrl.split('#')[0];
    return `${base}#page=${targetPage}&view=FitH&toolbar=1&navpanes=0`;
  };

  const syncPageUi = () => {
    if (pageInput) pageInput.value = String(page);
    if (pageCurrent) pageCurrent.textContent = String(page);
    if (prev) prev.disabled = page <= 1;
    if (next) next.disabled = page >= totalPages;
  };

  const goToPage = (targetPage) => {
    page = clampPage(targetPage);
    frame.src = pageUrl(page);
    hasLoaded = true;
    syncPageUi();
  };

  const focusable = () => Array.from(dialog.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )).filter((el) => !el.hidden && el.offsetParent !== null);

  const openViewer = (trigger) => {
    lastFocus = trigger || document.activeElement;
    viewer.hidden = false;
    viewer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('shem-brochure-scroll-lock');
    document.body.classList.add('shem-brochure-scroll-lock');
    if (!hasLoaded) goToPage(page);
    const closeButton = viewer.querySelector('[data-shem-brochure-close-button]');
    window.requestAnimationFrame(() => (closeButton || dialog).focus());
  };

  const closeViewer = () => {
    if (document.fullscreenElement && document.exitFullscreen) {
      document.exitFullscreen().catch(() => {});
    }
    viewer.hidden = true;
    viewer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('shem-brochure-scroll-lock');
    document.body.classList.remove('shem-brochure-scroll-lock');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  };

  openers.forEach((opener) => opener.addEventListener('click', () => openViewer(opener)));
  closers.forEach((closer) => closer.addEventListener('click', closeViewer));

  if (prev) prev.addEventListener('click', () => goToPage(page - 1));
  if (next) next.addEventListener('click', () => goToPage(page + 1));

  if (pageInput) {
    pageInput.max = String(totalPages);
    pageInput.addEventListener('change', () => goToPage(pageInput.value));
    pageInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        goToPage(pageInput.value);
        pageInput.blur();
      }
    });
  }

  if (fullscreen) {
    fullscreen.addEventListener('click', async () => {
      try {
        if (!document.fullscreenElement && dialog.requestFullscreen) {
          await dialog.requestFullscreen();
        } else if (document.fullscreenElement && document.exitFullscreen) {
          await document.exitFullscreen();
        }
      } catch (_) {
        /* Native PDF remains usable if Fullscreen API is unavailable. */
      }
    });
  }

  document.addEventListener('fullscreenchange', () => {
    if (!fullscreen) return;
    const active = Boolean(document.fullscreenElement);
    fullscreen.setAttribute('aria-pressed', String(active));
    fullscreen.textContent = active ? 'Volledig scherm sluiten' : 'Volledig scherm';
  });

  viewer.addEventListener('keydown', (event) => {
    if (viewer.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeViewer();
      return;
    }

    if (event.key === 'ArrowLeft' && document.activeElement !== pageInput) {
      event.preventDefault();
      goToPage(page - 1);
      return;
    }

    if (event.key === 'ArrowRight' && document.activeElement !== pageInput) {
      event.preventDefault();
      goToPage(page + 1);
      return;
    }

    if (event.key === 'Tab') {
      const items = focusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  syncPageUi();
})();
